import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const PanelledCoat = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.jackets.PanelledCoat.itemName}
      name={SS23.jackets.PanelledCoat.itemName}
      price={SS23.jackets.PanelledCoat.itemPrice}
      fabric={SS23.jackets.PanelledCoat.itemFabric}
      src={SS23.jackets.PanelledCoat.sizeChart}
      divId={SS23.jackets.PanelledCoat.shopifyDivId}
      mainId={SS23.jackets.PanelledCoat.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.jackets.PanelledCoat.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.jackets.PanelledCoat.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default PanelledCoat;
